import { Controller } from '@hotwired/stimulus'
import { downloadFilename } from '../../../modules/utils'

export default class extends Controller {
  static targets = ['spinner', 'text']

  declare readonly spinnerTarget: HTMLElement
  declare readonly textTarget: HTMLElement

  async start (event: Event): Promise<void> {
    event.preventDefault()

    const button = this.element as HTMLAnchorElement
    const url = button.href

    this.toggleLoading(true)

    try {
      const response = await fetch(url)
      if (!response.ok) throw new Error('Download failed')

      const blob = await response.blob()
      const filename = downloadFilename(response.headers.get('Content-Disposition'), 'report.pdf')

      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = filename
      document.body.appendChild(link)
      link.click()
      link.remove()
      URL.revokeObjectURL(link.href)
    } finally {
      this.toggleLoading(false)
    }
  }

  toggleLoading (isLoading: boolean): void {
    this.spinnerTarget.classList.toggle('hidden', !isLoading)
    this.textTarget.classList.toggle('opacity-50', isLoading)
    this.element.classList.toggle('pointer-events-none', isLoading)
    this.element.classList.toggle('opacity-60', isLoading)
  }
}
